import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SheetSlotComponentBase } from 'src/app/services/sheets-renderer.service';
import { BloodGasResultsActionV2 } from 'src/app/types/sheet-action-aggregate-graph.types';
import { TickValueComponent } from '../../tick-value/tick-value.component';

@Component({
	selector: 'app-blood-gas-results-slot-v2',
	templateUrl: './blood-gas-results-slot-v2.component.html',
	styleUrl: './blood-gas-results-slot-v2.component.scss',
	imports: [TickValueComponent],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class BloodGasResultsSlotComponentV2 implements SheetSlotComponentBase {

	@Input() action!: BloodGasResultsActionV2;
	value = null;

	constructor() {
	}
}
